export default __webpack_public_path__ + "media/edit.2f7ab0d2.svg";